import styled from 'styled-components';

export const CommonWidgetContainer = styled.a`
    height: 250px;
    width: 100%;
    color: #000000;
    cursor: pointer;
    border-radius: 2px;
    text-decoration: none;
`;

export const LazyLoadContainer = styled.div`
    display: flex;
    height: 250px;
    width: 100%;
`;